import React from "react";
import { Job } from "./types";
import { Spinner } from "../../utils/Spinner";
import { friendlyStatus } from "./utils";
import { actionDisplayName } from "../../ui/BulkActionsDropdown";

type JobTableRowProps = {
  job: Job;
  isLoading: boolean;
  isPending: boolean;
};

export const JobTableRow: React.FC<JobTableRowProps> = ({
  job,
  isLoading,
  isPending,
}) => {
  const currentHref = window.location.href.split("?")[0];
  return (
    <tr
      {...(isLoading ? { className: "tw-animate-pulse tw-text-gray-500" } : {})}
    >
      <td>
        {isLoading ? (
          <>{job.id}</>
        ) : (
          <a href={`${currentHref}/${job.id}`}>{job.id}</a>
        )}
      </td>
      <td>{job.user_email || "Unknown"}</td>
      <td>{actionDisplayName(job.action_name)}</td>
      <td>
        <div className="tw-flex tw-items-center tw-flex-col">
          {friendlyStatus(job.status_from_tasks_result)}{" "}
          {isPending && (
            <span className="tw-text-xs tw-text-gray-500 tw-animate-pulse">
              Checking Status...
            </span>
          )}
        </div>
      </td>
      <td>{job.created}</td>
    </tr>
  );
};

type JobsTableRowsProps = {
  jobs: Job[];
  notFound: boolean;
  isLoading: boolean;
  pendingJobIds: number[];
};

export const JobsTableRows: React.FC<JobsTableRowsProps> = ({
  jobs,
  notFound,
  isLoading,
  pendingJobIds,
}) => {
  if (notFound && !isLoading)
    return (
      <tr>
        <td colSpan={4}>No jobs found</td>
      </tr>
    );
  if (isLoading && notFound) {
    return (
      <tr className="tw-animate-pulse">
        <td colSpan={4}>
          <Spinner />
        </td>
      </tr>
    );
  }
  return (
    <>
      {jobs.map((job) => (
        <JobTableRow
          key={job.id}
          job={job}
          isLoading={isLoading}
          isPending={pendingJobIds.includes(job.id)}
        />
      ))}
    </>
  );
};
